import { render, staticRenderFns } from "./Section.vue?vue&type=template&id=58f78929"
import script from "./Section.vue?vue&type=script&setup=true&lang=js"
export * from "./Section.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Section.vue?vue&type=style&index=0&id=58f78929&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports